import React, { useState, useEffect } from 'react';
import './Transcript.css';

const TransDash = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [transcriptdata, setTranscriptData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submittedRange, setSubmittedRange] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [currentTranscript, setCurrentTranscript] = useState('');
    const [currentLiveTranscript, setCurrentLiveTranscript] = useState('');
    const [currentSessionid, setCurrentSessionid] = useState('');
    const [emailFilter, setEmailFilter] = useState('all');
    const [uniqueEmails, setUniqueEmails] = useState([]);
    const [isDataFetched, setIsDataFetched] = useState(false);  // New state to track if data is fetched
    const [openliveagent, setopenliveagent] = useState(false) //po-up
    const [iscurrentliveagent, setiscurrentliveagent] = useState(false) //state for liveagent
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => {
        const handleScroll = () => {
            const footer = document.querySelector('footer');
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                footer.style.display = 'block';
            } else {
                footer.style.display = 'none';
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!startDate || !endDate) return;

        const timer = setTimeout(() => {
            fetchFeedbackData(startDate, endDate);
            setSubmittedRange(`${startDate} - ${endDate}`);
        }, 2000);

        return () => clearTimeout(timer);
    }, [startDate, endDate]);


    const fetchFeedbackData = async (start, end) => {
        setIsLoading(true);
        try {
            const response = await fetch(`/api/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ start, end }),
            });
            const result = await response.json();
            setTranscriptData(result.transcript);
            const emails = result.transcript.map((trans) => trans.emailID);
            setUniqueEmails([...new Set(emails)]);
            setIsDataFetched(true); // Set the flag when data is fetched
        } catch (error) {
            console.error('Error fetching data:', error);
            setIsDataFetched(false); // If there's an error, reset the data flag
        } finally {
            setIsLoading(false);
        }
    };

    const formatTextWithBold = (text) => {
        const boldedText = text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
        const withParagraphs = boldedText.replace(/\n\n/g, '</p><p>');
        const formattedText = withParagraphs.replace(/\n/g, '<br />');
        return `<p>${formattedText}</p><br><br>`;
    };

    const handleSubmitDateRange = async () => {
        if (startDate && endDate) {
            setSubmittedRange(`${startDate} - ${endDate}`);
            fetchFeedbackData(startDate, endDate);
        } else {
            alert('Please select both start and end dates.');
        }
    };

    const handleShowTranscript = (trans) => {
        setCurrentTranscript(trans.transcript);
        setCurrentSessionid(trans.sessionid);
        setiscurrentliveagent(trans.isliveagent)
        setCurrentLiveTranscript(trans.liveagenttrans);
        setShowModal(true);
    };

    const handleShowLiveTranscript = (trans) => {
        setCurrentTranscript(trans.liveagenttrans);
        setCurrentSessionid(trans.sessionid);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };


    // Filtered transcript data based on the email filter
    const filteredData = emailFilter === 'all'
        ? transcriptdata
        : transcriptdata.filter((trans) => trans.emailID === emailFilter);

    return (
        <>
            <h1 style={{ textAlign: "center" }}>Transcript Dashboard</h1>
            <div className="container">
                <div className="datepickercontainer">
                    <div className="date-picker">
                        <div className="startdate">
                            <label htmlFor="start-date-picker">Start date:</label>
                            <input
                                type="date"
                                id="start-date-picker"
                                name="start-date-picker"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="enddate">
                            <label htmlFor="end-date-picker">End date:</label>
                            <input
                                type="date"
                                id="end-date-picker"
                                name="end-date-picker"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    {/* <button onClick={handleSubmitDateRange}>Submit Date Range</button> */}
                </div>

                {/* Show email filter dropdown only if data is fetched */}
                {isDataFetched && (
                    <div className="email-filter">
                        <label htmlFor="email-filter">Filter by Email:</label>

                        <div className="custom-dropdown">
                            {/* Selected Value */}
                            <div
                                className="dropdown-selected"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                {emailFilter === "all" ? "All Emails" : emailFilter}
                            </div>

                            {/* Dropdown */}
                            {isOpen && (
                                <div className="dropdown-menu">
                                    {/* Search Box */}
                                    <input
                                        type="text"
                                        placeholder="Search email..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        className="search-input"
                                    />

                                    {/* Options */}
                                    <div className="dropdown-options">
                                        {[
                                            "all",
                                            ...uniqueEmails.filter(
                                                (email) =>
                                                    email !== "all" &&
                                                    email.toLowerCase().includes(searchQuery.toLowerCase())
                                            ),
                                        ].map((email, index) => (
                                            <div
                                                key={index}
                                                className="dropdown-option"
                                                onClick={() => {
                                                    setEmailFilter(email);
                                                    setIsOpen(false);
                                                    setSearchQuery("");
                                                }}
                                            >
                                                {email === "all" ? "All Emails" : email}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {isLoading && <p>Loading...</p>}

                <div className="feedbacks">
                    <div className="feedbackscontents">
                        <h2>Transcript</h2>
                        {submittedRange && <p>{submittedRange}</p>}
                        <div className="table-container">
                            <table className="feedback-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Username</th>
                                        <th>Email</th>
                                        <th>Transcript</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((trans, index) => (
                                            <tr key={index}>
                                                <td>{trans.date}</td>
                                                <td>{trans.name}</td>
                                                <td>{trans.emailID}</td>
                                                <td>
                                                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                                        <button onClick={() => handleShowTranscript(trans)}>
                                                            Interaction
                                                        </button>
                                                        {trans.isliveagent && (
                                                            <button
                                                                style={{ backgroundColor: "#4c6074" }}
                                                                onClick={() => handleShowLiveTranscript(trans)}
                                                            >
                                                                LiveAgent
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>No transcript available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Modal for Transcript */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                Session ID : {currentSessionid}
                            </div>
                            <button className="close-modal" onClick={handleCloseModal}>
                                &times; Close
                            </button>
                            <div className="modal-transcript">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatTextWithBold(currentTranscript),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <footer>
                    <div className="footer-content">
                        <p></p>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default TransDash;
